import type { LucideIcon } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { Card } from '@/shared/ui/card/card';
import { CardContent } from '@/shared/ui/card/card-content';
import { Skeleton } from '@/shared/ui/skeleton/skeleton';

type StatCardProps = {
  readonly label: string;
  readonly value: string | number | undefined;
  readonly hint?: string;
  readonly icon?: LucideIcon;
  /** The figure that matters most on the page: primary-coloured, same card as the rest. */
  readonly highlight?: boolean;
};

export function StatCard({ label, value, hint, icon: Icon, highlight }: StatCardProps) {
  return (
    <Card size="sm" className={cn('h-full', highlight && 'ring-primary/30')}>
      <CardContent className="flex flex-col gap-1">
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
          {Icon && <Icon className="size-3.5" />}
          {label}
        </span>
        {value === undefined ? (
          <Skeleton className="h-7 w-12" />
        ) : (
          <span className={cn('text-xl font-semibold tabular-nums md:text-2xl', highlight && 'text-primary')}>
            {value}
          </span>
        )}
        {hint && <span className="text-xs text-muted-foreground tabular-nums">{hint}</span>}
      </CardContent>
    </Card>
  );
}
